import { useMemo } from "react"

import { CURRENCY } from "utils/constants"
import { BottomFixed, Discount, Price } from "components"
import { usePaymentContext } from "modules/Payment/PaymentContext"
import { getStartDate } from "modules/Payment/common/utils"
import { useApi, usePrice } from "modules/Payment/FormPage/common/hooks"
import { useGetPrice } from "modules/Payment/common/hooks"
import { Button } from "ui-kit/components-branded/index"
import { getOnlineOrOffline } from "modules/BookingCommon/common/utils"
import { NETWORK_ERROR_MESSAGE } from "modules/BookingCommon/common/constants"

export function NextPageButtonWithAdditionalInfoPay() {
    const [
        {
            payByCard,
            currency,
            isOnline,
            bookingDetails: { rfc3339_start_datetime, psy },
            errorMessage,
            bookSessionIsLoading,
        },
    ] = usePaymentContext()
    const { price, showDiscount, discount } = usePrice()
    const [, discountPrice] = useGetPrice()

    const isOnlineOrOffline = getOnlineOrOffline(isOnline)

    const isAutoPay = useMemo(() => {
        return !!payByCard?.external_id && currency === CURRENCY.RUB
    }, [payByCard?.external_id, currency])

    const { submitToPayment } = useApi(isAutoPay)

    const goToPaymentText = useMemo(() => {
        if (discountPrice === 0) {
            return "Записаться"
        } else {
            return isAutoPay ? "Оплатить" : "Перейти к оплате"
        }
    }, [discountPrice, isAutoPay])

    return (
        <div className="next-page-button-container">
            <BottomFixed className="booking__fixed-next-button">
                <div className="session-date__next-page-button-additional-info">
                    {isOnlineOrOffline}, {getStartDate(rfc3339_start_datetime)} (60 мин),{" "}
                    <Price singleServicePrice={price} psy={psy} currency={currency} />
                    &nbsp;
                    <Discount
                        singleServicePrice={discount}
                        psy={psy}
                        className="booking-cards__session-info-price-discount"
                        showDiscountInBooking={showDiscount}
                        currency={currency}
                    />
                </div>
                {errorMessage && (
                    <div className="booking__error-text">
                        {errorMessage || NETWORK_ERROR_MESSAGE}
                    </div>
                )}
                <Button
                    color="primary"
                    isFullwidth
                    onClick={() => {
                        void submitToPayment()
                    }}
                    disabled={bookSessionIsLoading}
                >
                    {goToPaymentText}
                </Button>
            </BottomFixed>
        </div>
    )
}
